import { render, staticRenderFns } from "./PasswordRecoveryModal.vue?vue&type=template&id=409dde2d&"
import script from "./PasswordRecoveryModal.vue?vue&type=script&lang=ts&"
export * from "./PasswordRecoveryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports